export const COLOR_LIST = [
    '#F2702E',
    '#EB3839',
    '#e57373',
    '#E50137',
    '#f73378',
]
